import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';
import { API } from '../config/api';

const MONEDAS = ['Colones', 'Dólares', 'Euros'];
const EMPRESAS = ['JyA Conusa', 'Cuenta Personal (JCNS)'];
const inputStyle = { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', outline: 'none', width: '100%', boxSizing: 'border-box', background: '#fff', fontFamily: 'Segoe UI, sans-serif' };
const labelStyle = { fontSize: '10px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', display: 'block' };
const btnGhost = { padding: '6px 12px', background: 'none', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', color: '#555' };

const plantillaVacia = () => ({ nombre: '', categoria_id: '', subcategoria_id: '', proyecto_id: '', moneda: 'Colones', monto_sugerido: '', tasa_iva: 13, empresa: 'JyA Conusa', medio_pago_id: '', periodicidad: 'Mensual', activo: true });

export default function GastosCatalogos() {
  const isAdmin = useAdmin();
  const [tab, setTab] = useState('catalogos');

  // Catalogos
  const [categorias, setCategorias] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [catSel, setCatSel] = useState(null);
  const [nuevaCat, setNuevaCat] = useState('');
  const [nuevaSub, setNuevaSub] = useState('');

  // Plantillas
  const [plantillas, setPlantillas] = useState([]);
  const [mediosPago, setMediosPago] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [modalP, setModalP] = useState(false);
  const [formP, setFormP] = useState(plantillaVacia());
  const [editP, setEditP] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => { cargarTodo(); }, []);

  const cargarTodo = async () => {
    try {
      const [cat, sub, pl, mp, proy] = await Promise.all([
        axios.get(`${API}/gastos-catalogos?tipo=categoria`),
        axios.get(`${API}/gastos-catalogos?tipo=subcategoria`),
        axios.get(`${API}/gastos-recurrentes`),
        axios.get(`${API}/listas?lista=gasto_medio_pago`),
        axios.get(`${API}/proyectos`)
      ]);
      setCategorias(cat.data || []);
      setSubcategorias(sub.data || []);
      setPlantillas((pl.data && pl.data.plantillas) || []);
      setMediosPago(mp.data || []);
      setProyectos(proy.data || []);
    } catch (e) { console.error(e); }
  };

  // ----- Categorias -----
  const addCat = async () => {
    if (!nuevaCat.trim()) return;
    await axios.post(`${API}/gastos-catalogos?tipo=categoria`, { nombre: nuevaCat.trim(), orden: categorias.length + 1 });
    setNuevaCat(''); cargarTodo();
  };
  const toggleCatActivo = async (c) => {
    await axios.put(`${API}/gastos-catalogos?tipo=categoria&id=${c.id}`, { nombre: c.nombre, orden: c.orden, activo: !c.activo });
    cargarTodo();
  };

  // ----- Subcategorias -----
  const subsDe = (catId) => subcategorias.filter(s => String(s.categoria_id) === String(catId));
  const addSub = async () => {
    if (!nuevaSub.trim() || !catSel) return;
    await axios.post(`${API}/gastos-catalogos?tipo=subcategoria`, { categoria_id: catSel.id, nombre: nuevaSub.trim(), orden: subsDe(catSel.id).length + 1 });
    setNuevaSub(''); cargarTodo();
  };
  const toggleSubActivo = async (s) => {
    await axios.put(`${API}/gastos-catalogos?tipo=subcategoria&id=${s.id}`, { categoria_id: s.categoria_id, nombre: s.nombre, orden: s.orden, activo: !s.activo });
    cargarTodo();
  };

  // ----- Plantillas -----
  const abrirNuevaP = () => { setFormP(plantillaVacia()); setEditP(null); setErr(''); setModalP(true); };
  const abrirEditarP = (p) => {
    setFormP({
      nombre: p.nombre, categoria_id: p.categoria_id || '', subcategoria_id: p.subcategoria_id || '',
      proyecto_id: p.proyecto_id || '', moneda: p.moneda, monto_sugerido: p.monto_sugerido ?? '',
      tasa_iva: p.tasa_iva ?? 13, empresa: p.empresa, medio_pago_id: p.medio_pago_id || '',
      periodicidad: p.periodicidad || 'Mensual', activo: !!p.activo
    });
    setEditP(p); setErr(''); setModalP(true);
  };
  const setP = (k, v) => setFormP(f => ({ ...f, [k]: v }));
  const guardarP = async () => {
    if (!formP.nombre.trim() || !formP.categoria_id || !formP.moneda || !formP.empresa) { setErr('Nombre, categoria, moneda y empresa son requeridos.'); return; }
    const body = {
      ...formP,
      categoria_id: parseInt(formP.categoria_id),
      subcategoria_id: formP.subcategoria_id ? parseInt(formP.subcategoria_id) : null,
      proyecto_id: formP.proyecto_id ? parseInt(formP.proyecto_id) : null,
      medio_pago_id: formP.medio_pago_id ? parseInt(formP.medio_pago_id) : null,
      monto_sugerido: formP.monto_sugerido === '' ? null : parseFloat(formP.monto_sugerido),
      tasa_iva: parseFloat(formP.tasa_iva)
    };
    try {
      if (editP) await axios.put(`${API}/gastos-recurrentes?id=${editP.id}`, body);
      else await axios.post(`${API}/gastos-recurrentes`, body);
      setModalP(false); cargarTodo();
    } catch (e) { setErr('Error: ' + (e.response?.data?.error || e.message)); }
  };
  const eliminarP = async (p) => {
    if (!window.confirm(`¿Eliminar la plantilla "${p.nombre}"?`)) return;
    try { await axios.delete(`${API}/gastos-recurrentes?id=${p.id}`); cargarTodo(); }
    catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  if (!isAdmin) return <div style={{ padding: '40px', fontFamily: 'Segoe UI, sans-serif', color: '#888' }}>Solo administradores.</div>;

  const subsForm = subcategorias.filter(s => String(s.categoria_id) === String(formP.categoria_id));

  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1100px' }}>
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '14px' }}>
        <span style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Catalogos de gastos</span>
        <div style={{ display: 'flex', background: 'rgba(255,255,255,0.1)', borderRadius: '20px', padding: '2px' }}>
          {[['catalogos', 'Categorias'], ['plantillas', 'Plantillas recurrentes']].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)}
              style={{ padding: '4px 16px', border: 'none', borderRadius: '20px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', background: tab === k ? '#fff' : 'transparent', color: tab === k ? '#012E40' : 'rgba(255,255,255,0.6)' }}>{l}</button>
          ))}
        </div>
      </div>

      {tab === 'catalogos' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          {/* Categorias */}
          <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#012E40', marginBottom: '12px' }}>Categorias</div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
              <input style={inputStyle} placeholder="Nueva categoria" value={nuevaCat} onChange={e => setNuevaCat(e.target.value)} onKeyDown={e => e.key === 'Enter' && addCat()} />
              <button onClick={addCat} style={{ padding: '8px 14px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>+ Agregar</button>
            </div>
            {categorias.map(c => (
              <div key={c.id} onClick={() => setCatSel(c)}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', borderRadius: '8px', cursor: 'pointer', marginBottom: '2px', background: catSel?.id === c.id ? '#eaf3de' : 'transparent', opacity: c.activo ? 1 : 0.5 }}>
                <span style={{ fontSize: '13px', color: '#1a1a1a', fontWeight: catSel?.id === c.id ? '600' : '400' }}>{c.nombre}</span>
                <button onClick={(e) => { e.stopPropagation(); toggleCatActivo(c); }} style={btnGhost}>{c.activo ? 'Desactivar' : 'Activar'}</button>
              </div>
            ))}
          </div>

          {/* Subcategorias */}
          <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', padding: '16px' }}>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#012E40', marginBottom: '12px' }}>
              {catSel ? `Subcategorias de ${catSel.nombre}` : 'Seleccioná una categoria'}
            </div>
            {catSel && (
              <>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                  <input style={inputStyle} placeholder="Nueva subcategoria" value={nuevaSub} onChange={e => setNuevaSub(e.target.value)} onKeyDown={e => e.key === 'Enter' && addSub()} />
                  <button onClick={addSub} style={{ padding: '8px 14px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}>+ Agregar</button>
                </div>
                {subsDe(catSel.id).map(s => (
                  <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', borderRadius: '8px', marginBottom: '2px', opacity: s.activo ? 1 : 0.5 }}>
                    <span style={{ fontSize: '13px', color: '#1a1a1a' }}>{s.nombre}</span>
                    <button onClick={() => toggleSubActivo(s)} style={btnGhost}>{s.activo ? 'Desactivar' : 'Activar'}</button>
                  </div>
                ))}
                {subsDe(catSel.id).length === 0 && <div style={{ color: '#bbb', fontSize: '13px' }}>Sin subcategorias.</div>}
              </>
            )}
          </div>
        </div>
      )}

      {tab === 'plantillas' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
            <button onClick={abrirNuevaP} style={{ padding: '8px 16px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>+ Nueva plantilla</button>
          </div>
          <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
            {plantillas.length === 0 ? (
              <div style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No hay plantillas recurrentes.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#f8f9fa' }}>
                    {['Plantilla', 'Categoria', 'Empresa', 'Periodicidad', 'Monto', 'Activo', ''].map(h => (
                      <th key={h} style={{ padding: '11px 14px', textAlign: 'left', color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {plantillas.map(p => (
                    <tr key={p.id} style={{ borderBottom: '1px solid #f3f3f3', opacity: p.activo ? 1 : 0.5 }}>
                      <td style={{ padding: '10px 14px', fontWeight: '500', color: '#1a1a1a' }}>{p.nombre}</td>
                      <td style={{ padding: '10px 14px', color: '#555' }}>{p.categoria_nombre}{p.subcategoria_nombre ? ` · ${p.subcategoria_nombre}` : ''}</td>
                      <td style={{ padding: '10px 14px', color: '#555' }}>{p.empresa}</td>
                      <td style={{ padding: '10px 14px', color: '#555' }}>{p.periodicidad}</td>
                      <td style={{ padding: '10px 14px', color: '#555' }}>{p.monto_sugerido != null ? `${p.moneda} ${Number(p.monto_sugerido).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : 'variable'}</td>
                      <td style={{ padding: '10px 14px', color: '#555' }}>{p.activo ? 'Si' : 'No'}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => abrirEditarP(p)} style={btnGhost}>Editar</button>
                          <button onClick={() => eliminarP(p)} style={{ ...btnGhost, border: '1px solid #fcc', color: '#A32D2D' }}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      {/* Modal plantilla */}
      {modalP && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '640px', maxHeight: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ background: '#012E40', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontSize: '15px', fontWeight: '700' }}>{editP ? 'Editar plantilla' : 'Nueva plantilla recurrente'}</span>
              <button onClick={() => setModalP(false)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '22px', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ overflowY: 'auto', padding: '24px' }}>
              {err && <div style={{ background: '#FCEBEB', border: '1px solid #f5c6c6', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#A32D2D', marginBottom: '12px' }}>{err}</div>}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div style={{ gridColumn: '1/-1' }}><label style={labelStyle}>Nombre *</label><input style={inputStyle} value={formP.nombre} onChange={e => setP('nombre', e.target.value)} /></div>
                <div>
                  <label style={labelStyle}>Categoria *</label>
                  <select style={inputStyle} value={formP.categoria_id} onChange={e => { setP('categoria_id', e.target.value); setP('subcategoria_id', ''); }}>
                    <option value="">— Seleccionar —</option>
                    {categorias.filter(c => c.activo).map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Subcategoria</label>
                  <select style={inputStyle} value={formP.subcategoria_id} onChange={e => setP('subcategoria_id', e.target.value)} disabled={!formP.categoria_id}>
                    <option value="">— (opcional) —</option>
                    {subsForm.filter(s => s.activo).map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Proyecto</label>
                  <select style={inputStyle} value={formP.proyecto_id} onChange={e => setP('proyecto_id', e.target.value)}>
                    <option value="">Sin proyecto (overhead)</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.id_proyecto} — {p.nombre}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Empresa *</label>
                  <select style={inputStyle} value={formP.empresa} onChange={e => setP('empresa', e.target.value)}>
                    {EMPRESAS.map(x => <option key={x} value={x}>{x}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Moneda *</label>
                  <select style={inputStyle} value={formP.moneda} onChange={e => setP('moneda', e.target.value)}>
                    {MONEDAS.map(m => <option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Monto sugerido (vacio = variable)</label>
                  <input type="number" step="0.01" style={inputStyle} value={formP.monto_sugerido} onChange={e => setP('monto_sugerido', e.target.value)} placeholder="en blanco = se genera sin monto" />
                </div>
                <div>
                  <label style={labelStyle}>IVA</label>
                  <select style={inputStyle} value={formP.tasa_iva} onChange={e => setP('tasa_iva', e.target.value)}>
                    <option value={13}>IVA 13%</option>
                    <option value={0}>IVA 0% / exento</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Medio de pago</label>
                  <select style={inputStyle} value={formP.medio_pago_id} onChange={e => setP('medio_pago_id', e.target.value)}>
                    <option value="">— Ninguno —</option>
                    {mediosPago.map(m => <option key={m.id} value={m.id}>{m.valor}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Periodicidad</label>
                  <select style={inputStyle} value={formP.periodicidad} onChange={e => setP('periodicidad', e.target.value)}>
                    <option value="Mensual">Mensual</option>
                    <option value="Anual">Anual</option>
                  </select>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '20px' }}>
                  <input type="checkbox" checked={formP.activo} onChange={e => setP('activo', e.target.checked)} id="pactivo" />
                  <label htmlFor="pactivo" style={{ fontSize: '13px', color: '#555' }}>Plantilla activa</label>
                </div>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setModalP(false)} style={{ padding: '9px 20px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>Cancelar</button>
              <button onClick={guardarP} style={{ padding: '9px 24px', background: '#012E40', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>{editP ? 'Guardar cambios' : 'Crear plantilla'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
